<div class="contact_manager__container" [nativeDesktopStyle]="{ 'font-size' : '12px' }">
  <div class="bfx-section-wrapper">
    <p-tabView [activeIndex]="activeTab" (onChange)="onTabChange($event)" styleClass="bfx-tabview">
      <p-tabPanel
        header="Contacts"
        [disabled]="locked"
        [headerStyle]="{'width': enableClientTraders ? '' : '50%'}"
      >
        <div class="overflow-hidden">
          <div *ngIf="ready">
            <div style="overflow-x: auto">
              <p-dataTable
                [value]="clientContacts"
                resizableColumns="true"
                columnResizeMode="expand"
                nativeDesktopTable
                [(selection)]="selectedContact"
                [scrollable]="true"
                [emptyMessage]="emptyMessage"
                [rowStyleClass]="rowStyleClass"
                sortField="contactNameTxt"
                selectionMode="single"
                scrollHeight="100%"
                (onRowDblclick)="editItem($event)"
                dataKey="index"
              >
                <p-column
                  headerStyleClass="contact-header"
                  field="selected"
                  header="Sel."
                  [style]="{'width':'60px'}"
                  [sortable]="true"
                  styleClass="centered"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <p-checkbox
                      [(ngModel)]="data.selected"
                      binary="true"
                      [disabled]="locked"
                    ></p-checkbox>
                  </ng-template>
                </p-column>
                <p-column
                  field="isDefaultFg"
                  header="Default"
                  [style]="{'width':'80px'}"
                  [sortable]="true"
                  headerStyleClass="contact-header"
                  styleClass="centered"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <p-checkbox
                      [(ngModel)]="data.isDefaultFg"
                      binary="true"
                      [disabled]="true"
                    ></p-checkbox>
                  </ng-template>
                </p-column>
                <p-column
                  field="contactNameTxt"
                  header="Contact Name"
                  [style]="{'width':'180px'}"
                  [sortable]="true"
                ></p-column>
                <p-column
                  field="emailTxt"
                  header="Email"
                  [style]="{'width':'200px'}"
                  [sortable]="true"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    <span style="width: 100%; overflow: hidden; text-overflow: ellipsis"
                      >{{data.emailTxt}}</span
                    >
                  </ng-template>
                </p-column>
                <p-column
                  field="smsTxt"
                  header="SMS"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                ></p-column>
                <p-column
                  field="mobileTxt"
                  header="Mobile"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                ></p-column>
                <p-column
                  field="deskTxt"
                  header="Desk"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                ></p-column>
                <p-column
                  field="notifyEntry"
                  header="Notify Entry"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    {{getNotificationLabel(data.notifyEntry)}}
                  </ng-template>
                </p-column>
                <p-column
                  field="notifyModify"
                  header="Notify Modify"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    {{getNotificationLabel(data.notifyModify)}}
                  </ng-template>
                </p-column>
                <p-column
                  field="notifyFill"
                  header="Notify Fill"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    {{getNotificationLabel(data.notifyFill)}}
                  </ng-template>
                </p-column>
                <p-column
                  field="notifyExpiry"
                  header="Notify Expiry"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    {{getNotificationLabel(data.notifyExpiry)}}
                  </ng-template>
                </p-column>
                <p-column
                  field="notifyCancel"
                  header="Notify Cancel"
                  [style]="{'width':'120px'}"
                  [sortable]="true"
                >
                  <ng-template let-col let-data="rowData" pTemplate="body">
                    {{getNotificationLabel(data.notifyCancel)}}
                  </ng-template>
                </p-column>
              </p-dataTable>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel
        header="Comments"
        styleClass="user-settings-tab-panel"
        [disabled]="locked"
        [headerStyle]="{'width': enableClientTraders ? '' : '50%'}"
      >
        <div *ngIf="ready" class="comment-container">
          <div class="comment-section">
            <label class="comment-section-label" for="client-comment">Client Comments</label>
            <textarea
              id="client-comment"
              class="comment-section-input"
              pInputTextarea
              [(ngModel)]="clientComment"
              [disabled]="locked || !editable"
              rows="4"
              [maxlength]="commentSize"
            ></textarea>
          </div>
          <bfx-comment-warning></bfx-comment-warning>
          <div *ngIf="enablePrivateComments" class="comment-section">
            <label class="comment-section-label" for="private-comment">Private Comments</label>
            <textarea
              id="private-comment"
              class="comment-section-input"
              pInputTextarea
              [(ngModel)]="privateComment"
              [disabled]="locked || !editable"
              rows="4"
              [maxlength]="commentSize"
            ></textarea>
          </div>
          <bfx-comment-warning *ngIf="enablePrivateComments"></bfx-comment-warning>
        </div>
      </p-tabPanel>
      <p-tabPanel
        *ngIf="enableClientTraders"
        header="Client Trader"
        styleClass="user-settings-tab-panel"
        emptyMessage=""
        [disabled]="locked"
      >
        <div *ngIf="ready" class="user-notification-component-container">
          <div style="overflow-x: auto">
            <p-dataTable
              [value]="clientTraders"
              resizableColumns="true"
              columnResizeMode="expand"
              nativeDesktopTable
              [(selection)]="selectedClientTrader"
              selectionMode="single"
              sortField="userName"
              scrollable="true"
              scrollHeight="100%"
              [style]="{height: scrollHeight}"
              (onRowDblclick)="editItem($event)"
              dataKey="index"
            >
              <p-column
                field="selected"
                header="Sel."
                [style]="{'width':'60px'}"
                [sortable]="true"
                headerStyleClass="contact-header"
                styleClass="centered"
              >
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <p-checkbox
                    [(ngModel)]="data.selected"
                    binary="true"
                    (onChange)="clientTraderSelectionChanged($event, data)"
                    [disabled]="locked"
                  ></p-checkbox>
                </ng-template>
              </p-column>
              <p-column
                field="isDefault"
                header="Default"
                [style]="{'width':'80px'}"
                [sortable]="true"
                headerStyleClass="contact-header"
                styleClass="centered"
              >
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <p-checkbox
                    [(ngModel)]="data.isDefault"
                    binary="true"
                    [disabled]="true"
                  ></p-checkbox>
                </ng-template>
              </p-column>
              <p-column
                field="userName"
                header="Client Trader Name"
                [style]="{'width':'180px'}"
                [sortable]="true"
              ></p-column>
              <p-column
                field="comment"
                header="Client Trader Comment"
                [style]="{'width':'180px'}"
                [sortable]="true"
              >
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <span
                    style="
                      width: 100%;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                    title="{{data.comment}}"
                    >{{data.comment}}</span
                  >
                </ng-template>
              </p-column>
              <p-column
                field="smsNumber"
                header="Mobile"
                [style]="{'width':'120px'}"
                [sortable]="true"
              ></p-column>
              <p-column
                field="desk"
                header="Desk"
                [style]="{'width':'120px'}"
                [sortable]="true"
              ></p-column>
              <p-column
                field="emailAddress"
                header="Email"
                [style]="{'width':'200px'}"
                [sortable]="true"
              >
                <ng-template let-col let-data="rowData" pTemplate="body">
                  <span
                    style="width: 100%; overflow: hidden; text-overflow: ellipsis"
                    title="{{data.emailAddress}}"
                    >{{data.emailAddress}}</span
                  >
                </ng-template>
              </p-column>
            </p-dataTable>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
  <div class="divider"></div>
  <div fxLayout="row" class="btn-bar bfx-footer-bar-container">
    <div class="footer-left">
      <ng-container *ngIf="activeTab !== 1">
        <button
          class="bfx-button-secondary"
          (click)="newItem($event)"
          [disabled]="locked || !editable"
        >
          New
        </button>
        <button
          class="bfx-button-secondary"
          [disabled]="!isItemActionEnabled() || locked || !editable"
          (click)="editItem($event)"
        >
          Edit
        </button>
        <button
          class="bfx-button-secondary"
          [disabled]="!isItemActionEnabled() || locked || !editable"
          (click)="deleteItem()"
        >
          Delete
        </button>
      </ng-container>
    </div>
    <div class="footer-right">
      <button
        class="bfx-button-negative"
        [disabled]="!isSaveEnabled() || locked"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button class="bfx-button-primary" [disabled]="!isSaveEnabled() || locked" (click)="save()">
        Save
      </button>
    </div>
  </div>
</div>
